import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/industries/page.tsx");
